class PlugLottieIcons extends HTMLElement {
    constructor() {
        super();
        window.PLUG.utils.bindThisToAllMethods(this);

        this.animations = [];
        this.initializingAnimations = false
        this.initializedAnimations = false
        this.preIntersectionProcessed = false;
        this.postIntersectionProcessed = false;
        this.lottiePath = this.dataset.lottiePath;
        this.sectionId = this.dataset.sectionId;
        this.elements = {
            blocks: Array.from(this.getElementsByClassName("plug-value-props__prop")),
            lottieLibraryScript: document.getElementById(`lottie-script-${this.sectionId}`),
        };
        const section = this.closest("section");
        const intersectionObserver = this.createObserver();
        intersectionObserver.observe(section);

        // this.slider = this.initSlider();
        // window.PLUG.utils.afterNextFrame(async () => {
        //     // await this.equalizeTitleAndDescriptionHeights(true);
        //     this.elements.slider.closest(".about-sog__slider")!.classList.remove("is-see-through");
        // });

        // const resizeDebounce = window.PLUG.utils.debounce(this.handleResize, 300);
        // window.addEventListener("resize", () => {
        //     resizeDebounce();
        // });
    }

    handleIntersection(entries, observer) {
        const entry = entries[0];

        if (!entry.isIntersecting) return;

        if (!this.preIntersectionProcessed && .01 <= entry.intersectionRatio) {
            this.preIntersectionProcessed = true;
            this.initLottieAnimations().catch(err => console.error(err));
        }

        if (!this.postIntersectionProcessed && .75 <= entry.intersectionRatio) {
            this.postIntersectionProcessed = true;
            observer.unobserve(entry.target);
            if (this.initializedAnimations) {
                this.runAnimations();

            } else if (this.initializingAnimations) {
                const waitForAnimations = (attempts) => {
                    if (this.initializedAnimations) {
                        return this.runAnimations();
                    }
                    if (attempts < 100) {
                        setTimeout(waitForAnimations, 50, attempts + 1);
                    } else {
                        throw new Error("Animations failed to initialize in time.");
                    }
                };
                waitForAnimations(0);

            } else {
                this.initLottieAnimations()
                    .then(() => this.runAnimations())
                    .catch(e => console.error(e));
            }
        }
    }

    createObserver() {
        const options = {
            rootMargin: "0px 0px 0px 0px",
            threshold: [.01, .75]
        };
        return new IntersectionObserver(this.handleIntersection, options);
    }

    async initLottieAnimations() {
        console.log("initLottieAnimations");
        if (this.initializingAnimations || this.initializedAnimations) {
            return;
        }
        this.initializingAnimations = true;
        await this.loadLottieScript();
        const lottieFiles = this.getLottieFileData();

        this.animations = this.elements.blocks.map(block => {
            const lottieContainer = block.querySelector(".plug-value-props__lottie-icon");
            if (lottieContainer === null) {
                return;
            }
            const lottieName = lottieContainer.dataset.plugLottieIcon;
            return window.bodymovin.loadAnimation({
                container: lottieContainer,
                path: lottieFiles[lottieName],
                renderer: "svg",
                loop: true,
                autoplay: false,
                name: lottieName
            });
        });
        this.initializingAnimations = false;
        this.initializedAnimations = true;
    }

    loadLottieScript() {
        const script = this.elements.lottieLibraryScript;

        return new Promise((resolve, reject) => {
            if (script.dataset.loaded === "true") {
                return resolve();
            }
            script.dataset.loaded = "true";

            script.addEventListener("load", () => {
                resolve();
            });

            script.addEventListener("error", (ev) => {
                console.log("Error on loading file", ev);
                reject();
            });

            script.src = script.dataset.src;
        });
    }

    getLottieFileData() {
        const jsonScript = document.getElementById(`lottie-file-data-${this.sectionId}`);
        if (jsonScript === null) {
            throw new Error("Cannot find file data script for lottie files.");
        }
        const scriptData = JSON.parse(jsonScript.innerHTML);
        const lottieFiles = scriptData.lottieFiles;
        return lottieFiles;
    }

    isMobile() {
        return window.innerWidth < 750;
    }

    isTablet() {
        return window.innerWidth < 1200;
    }

    runAnimations() {
        const completedAnimationIndices = [];

        const runAnimation = (index, playNext = false) => {
            const alreadyRan = completedAnimationIndices.includes(index);
            if (!alreadyRan) {
                const animation = this.animations[index];
                const lottieIcon = this.elements.blocks[index].querySelector(".plug-value-props__lottie-icon");
                lottieIcon.classList.remove("is-see-through");
                animation.play();
                completedAnimationIndices.push(index);
            }

            if (playNext && index < this.animations.length - 1) {
                if (!alreadyRan) {
                    setTimeout(runAnimation, 500, index + 1, true);
                } else {
                    runAnimation(index + 1, true);
                }
            }
        };
        //
        // const runMobileAnimations = () => {
        //     runAnimation(this.slider.activeIndex);
        // };
        //
        // const runTabletAnimations = () => {
        //     const activeIndex = this.slider.activeIndex;
        //     const nextIndex = activeIndex + 1;
        //     const alreadyRanActiveSlide = completedAnimationIndices.includes(activeIndex);
        //     const alreadyRanNextSlide = completedAnimationIndices.includes(nextIndex);
        //     if (!alreadyRanActiveSlide) {
        //         runAnimation(activeIndex);
        //         if (!alreadyRanNextSlide) {
        //             setTimeout(runAnimation, 1000, nextIndex);
        //         }
        //     } else if (!alreadyRanNextSlide) {
        //         runAnimation(nextIndex);
        //     }
        // };

        const runDesktopAnimations = () => {
            runAnimation(0, true);
        };

        runAnimation(0, true);
        // const runAppropriateAnimations = () => {
        //     if (this.isMobile()) {
        //         runMobileAnimations();
        //     } else if (this.isTablet()) {
        //         runTabletAnimations();
        //     } else {
        //         runDesktopAnimations();
        //     }
        // };
        //
        // // this.slider.on("slideChange", runAppropriateAnimations);
        // // this.slider.on("resize", runAppropriateAnimations);
        // runAppropriateAnimations();
    }

    // handleResize() {
    //     this.equalizeTitleAndDescriptionHeights().catch(err => console.error(err));
    // }
    //
    // initSlider() {
    //     return new window.Swiper(`.swiper-${this.sectionId}`, {
    //         direction: "horizontal",
    //         loop: false,
    //         slidesPerView: 1.2,
    //         spaceBetween: 14,
    //         watchOverflow: true,
    //         breakpoints: {
    //             750: {
    //                 slidesPerView: 2.2,
    //                 spaceBetween: 26,
    //             },
    //             1200: {
    //                 slidesPerView: 4,
    //                 spaceBetween: 26,
    //             }
    //         },
    //     });
    // }
    //
    // equalizeTitleAndDescriptionHeights(firstTime = false): Promise<void> {
    //     const blocks = this.elements.blocks;
    //
    //     function equalize() {
    //         const titles = blocks.map(block => block.querySelector(".about-sog-block__title") as HTMLElement);
    //         const descriptions = blocks.map(block => block.querySelector(".about-sog-block__description") as HTMLElement);
    //         const maxTitleHeight: number = titles.reduce((max, current) => {
    //             return current ? Math.max(max, current.getBoundingClientRect().height) : max;
    //         }, 0);
    //         const maxDescriptionHeight: number = descriptions.reduce((max, current) => {
    //             return current ? Math.max(max, current.getBoundingClientRect().height) : max;
    //         }, 0);
    //         titles.forEach((title) => {
    //             title.style.height = `${maxTitleHeight}px`;
    //         });
    //         descriptions.forEach((description) => {
    //             description.style.height = `${maxDescriptionHeight}px`;
    //         });
    //     }
    //
    //     return new Promise((resolve) => {
    //         if (firstTime) {
    //             equalize();
    //             return resolve();
    //         } else {
    //             const titles: HTMLElement[] = [];
    //             const descriptions: HTMLElement[] = [];
    //             blocks.forEach((block) => {
    //                 const title = block.querySelector(".about-sog-block__title") as HTMLElement;
    //                 const description = block.querySelector(".about-sog-block__description") as HTMLElement;
    //                 title.style.height = "";
    //                 description.style.height = "";
    //                 description.style.transitionDuration = "0";
    //                 title.style.transitionDuration = "0";
    //                 titles.push(title);
    //                 descriptions.push(description);
    //             });
    //             window.PLUG.utils.afterNextFrame(() => {
    //                 titles.forEach(title => {
    //                     title.style.height = `${title.getBoundingClientRect().height}px`
    //                 });
    //                 descriptions.forEach(description => {
    //                     description.style.height = `${description.getBoundingClientRect().height}px`
    //                 });
    //                 window.PLUG.utils.afterNextFrame(() => {
    //                     titles.forEach(title => {
    //                         title.style.transitionDuration = "";
    //                     });
    //                     descriptions.forEach(description => {
    //                         description.style.transitionDuration = "";
    //                     });
    //                     equalize();
    //                     return resolve();
    //                 });
    //             });
    //         }
    //     });
    // }
}

customElements.define("plug-lottie-icons", PlugLottieIcons);